import { useEffect } from 'react';
import { useFilter } from '../modules/Filter/components/FilterContext';
import { useExpand } from '../modules/Map/components/ExpandContext';

const useExpandContextWithFilters = () => {
  const { expandAll, resetAll } = useExpand();
  const { getActiveFilters, getSearchFilter } = useFilter();

  const activeFilters = getActiveFilters().length > 0 || getSearchFilter() !== undefined;

  useEffect(() => (activeFilters ? expandAll() : resetAll()), [activeFilters]);
};

export default useExpandContextWithFilters;
